import dynamic from 'next/dynamic';
import { ReactNode } from 'react';
import { useSelector } from 'react-redux';
import { selectors } from 'global/MainLayout/slice';
import useProfileData from 'hooks/useProfileData';
import useNotificationListener from 'hooks/useNotificationListener';
import TradingContextProvider from 'features/transaction/provider';
import { ChartbitLayoutWrapper } from './styled';

const SideWidget = dynamic(() => import('global/MainLayout/SideWidget'), {
  ssr: false,
});
const ModalErrorManager = dynamic(
  () => import('global/MainLayout/ModalErrorMessage/ModalErrorManager'),
  {
    ssr: false,
  },
);
const ModalAuthSecurities = dynamic(
  () => import('features/securities/AuthModal'),
  {
    ssr: false,
  },
);
const GlobalModalManager = dynamic(() => import('global/GlobalModalManager'), {
  ssr: false,
});
const ModalTransactionSecurities = dynamic(
  () => import('global/TradingModal'),
  {
    ssr: false,
  },
);
const DatafeedModalManager = dynamic(
  () => import('global/Datafeed/modal/ModalManager'),
  { ssr: false },
);

interface ChartbitLayoutProps {
  children: ReactNode;
}

function ChartbitLayout({ children }: ChartbitLayoutProps) {
  useProfileData();
  useNotificationListener();
  const { isSideWidgetOpen, isMarketOpen } = useSelector(selectors);

  return (
    <>
      <SideWidget />
      <ChartbitLayoutWrapper
        isSideWidgetOpen={isSideWidgetOpen}
        isMarketOpen={isMarketOpen}
      >
        {children}
      </ChartbitLayoutWrapper>
      <ModalErrorManager />
      <ModalAuthSecurities />
      <GlobalModalManager />
      <TradingContextProvider>
        <ModalTransactionSecurities />
      </TradingContextProvider>

      {/* Datafeed Modal */}
      <DatafeedModalManager />
    </>
  );
}

export default ChartbitLayout;
